// extracted by mini-css-extract-plugin
export default {"Input":"VueRapport_Input__KVim2","contenuEnTete":"VueRapport_contenuEnTete__ajD0m","titre":"VueRapport_titre__FzdRd","bold":"VueRapport_bold__7kDP5"};